import { EMAIL_TEMPLATE_SUGGESTION_LANGUAGES } from '@realadvisor/constants';

const BROCHURE_URL_SUGGESTION_PREFIX = '#property_lot_brochureURL';

export const isBrochureUrlSuggestion = (id: string): boolean =>
  id === BROCHURE_URL_SUGGESTION_PREFIX ||
  (id.startsWith(`${BROCHURE_URL_SUGGESTION_PREFIX}_`) &&
    (EMAIL_TEMPLATE_SUGGESTION_LANGUAGES as readonly string[]).includes(
      id.slice(BROCHURE_URL_SUGGESTION_PREFIX.length + 1),
    ));

export const isResolvedBrochureSuggestion = (
  id: string,
  value: string,
): boolean => isBrochureUrlSuggestion(id) && /^https?:\/\//i.test(value);
